import "./sidebar.css"
import {
  PermIdentity,
  Storefront,
  PlaylistAdd,
  List,
  DesktopWindows,
} from "@material-ui/icons"
import LogoutIcon from "@mui/icons-material/Logout"
import SellIcon from "@mui/icons-material/Sell"
import { Link, useLocation } from "react-router-dom"
import { useDispatch } from "react-redux"
import { logout } from "../../redux/apiCalls"

export default function Sidebar() {
  const pathname = useLocation().pathname
  const dispatch = useDispatch()

  const onLogout = () => {
    logout(dispatch)
  }
  const checkPathname = (link) => {
    return link === pathname ? "active" : ""
  }
  return (
    <div className='sidebar'>
      <div className='sidebarWrapper'>
        <div className='sidebarMenu'>
          <h3 className='sidebarTitle'>Dashboard</h3>
          <ul className='sidebarList'>
            <Link to='/' className='link'>
              <li className={`sidebarListItem ${checkPathname("/")}`}>
                <DesktopWindows className='sidebarIcon' />
                Home
              </li>
            </Link>
          </ul>
        </div>
        <div className='sidebarMenu'>
          <h3 className='sidebarTitle'>Quick Menu</h3>
          <ul className='sidebarList'>
            <Link to='/users' className='link'>
              <li className={`sidebarListItem ${checkPathname("/users")}`}>
                <PermIdentity className='sidebarIcon' />
                Clients
              </li>
            </Link>
            <Link to='/orders' className='link'>
              <li className={`sidebarListItem ${checkPathname("/orders")}`}>
                <SellIcon className='sidebarIcon' />
                Orders
              </li>
            </Link>
            <Link to='/products' className='link'>
              <li className={`sidebarListItem ${checkPathname("/products")}`}>
                <Storefront className='sidebarIcon' />
                Products
              </li>
            </Link>
            <Link to='/newproduct' className='link'>
              <li className={`sidebarListItem ${checkPathname("/newproduct")}`}>
                <PlaylistAdd className='sidebarIcon' />
                Add a product
              </li>
            </Link>
            <Link to='/categories' className='link'>
              <li className={`sidebarListItem ${checkPathname("/categories")}`}>
                <List className='sidebarIcon' />
                Categories
              </li>
            </Link>
            <Link to='/newcategory' className='link'>
              <li
                className={`sidebarListItem ${checkPathname("/newcategory")}`}>
                <PlaylistAdd className='sidebarIcon' />
                Add a category
              </li>
            </Link>
            <Link to='#' onClick={onLogout} className='link'>
              <li className='sidebarListItem'>
                <LogoutIcon className='sidebarIcon' />
                Logout
              </li>
            </Link>
          </ul>
        </div>
      </div>
    </div>
  )
}
